import { FC, useEffect, useState } from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';
import { generateRandomAnswers } from './utils';
import AnswerButtonBackgroundImage from '../../assets/images/metro/AnswerButtonBackground.svg';
import TubeImage from '../../assets/images/metro/game/Tube.svg';

type ButtonState = 'default' | 'correct' | 'incorrect';

type Props = {
  className?: string;
  correctAnswer: number | null;
  onClickWrong: VoidFunction;
  onClickCorrect: VoidFunction;
  offsetAnswer: number;
};

const defaultButtonsState: ButtonState[] = ['default', 'default', 'default'];

const AnswerButtons: FC<Props> = ({ correctAnswer, className, onClickWrong, onClickCorrect, offsetAnswer }) => {
  const [buttonStates, setButtonStates] = useState<ButtonState[]>(defaultButtonsState);
  const [answers, setAnswers] = useState<number[]>([]);
  const [disableButtons, setDisableButtons] = useState(false);
  const isAnswer = typeof correctAnswer === 'number';
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (!isAnswer) {
      return;
    }

    setIsInitialized(true);
  }, [isAnswer]);

  useEffect(() => {
    if (!isAnswer) {
      return;
    }

    const newAnswers = generateRandomAnswers(correctAnswer, offsetAnswer);
    setButtonStates(defaultButtonsState);
    setAnswers(newAnswers);
    setDisableButtons(false);
  }, [correctAnswer, isAnswer, offsetAnswer]);

  const handleButtonClick = (index: number) => {
    let isCorrect = answers[index] === correctAnswer;

    setButtonStates((prevButtonStates) => {
      const newButtonStates = [...prevButtonStates];

      if (isCorrect) {
        newButtonStates[index] = 'correct';
      } else {
        newButtonStates[index] = 'incorrect';
        const correctIndex = answers.findIndex((answer) => answer === correctAnswer);
        if (correctIndex !== -1) {
          newButtonStates[correctIndex] = 'correct';
        }
      }

      return newButtonStates;
    });

    isCorrect && onClickCorrect();
    !isCorrect && onClickWrong();
    setDisableButtons(true);
  };

  return (
    <div className={classNames(styles.answerButtons, className)}>
      <img src={TubeImage} alt="" className={classNames(styles.tubeImage, styles.left)} />
      <img src={TubeImage} alt="" className={classNames(styles.tubeImage, styles.right)} />

      <div className={styles.background}>
        <div className={styles.container}>
          <div
            className={classNames(styles.question, {
              [styles.fadeIn]: isAnswer,
              [styles.fadeOut]: !isAnswer && isInitialized,
            })}
          >
            <div className={styles.text}>
              Сколько человек
              <br />
              сейчас в метро?
            </div>

            <div className={styles.buttons}>
              {answers.map((number, index) => (
                <button
                  key={number}
                  className={classNames(styles.button, styles[buttonStates[index]])}
                  disabled={disableButtons}
                  onClick={() => handleButtonClick(index)}
                  type="button"
                >
                  <img className={styles.buttonImage} alt="" src={AnswerButtonBackgroundImage} />
                  <span className={styles.number}>{number}</span>
                </button>
              ))}
            </div>
          </div>

          <div
            className={classNames(styles.progress, {
              [styles.fadeOut]: isAnswer,
              [styles.fadeIn]: !isAnswer && isInitialized,
            })}
          >
            ...Наблюдай...
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnswerButtons;
